interface Props {
  fill?: string,
  width: string,
  height: string,
  className: string,
}

const PersonalBest = ({
  fill = '#1a1818',
  width,
  height,
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37.32 38.31"
    width={width}
    height={height}
    className={className}
  >
    <g id="Layer_2">
      <g id="Layer_1-2">
        <path
          fill={fill}
          className="cls-1"
          d="M37.32,4a3.76,3.76,0,0,0-3.76-4H3.77A3.76,3.76,0,0,0,0,4,18.3,18.3,0,0,0,2.07,11.7,16.31,16.31,0,0,0,6,16.54c.28.23.56.45.83.65a11.54,11.54,0,0,0,10.43,9.9V29.8A7.86,7.86,0,0,0,14,31.1a5.46,5.46,0,0,0-2.45,4.44v2.76H25.8V35.54a5.46,5.46,0,0,0-2.45-4.44A7.86,7.86,0,0,0,20,29.8V27.1a11.54,11.54,0,0,0,10.43-9.9c.27-.2.55-.42.83-.65a16.31,16.31,0,0,0,3.95-4.84A18.3,18.3,0,0,0,37.32,4ZM27.07,19.14a8.79,8.79,0,0,1-8,5.24h-.74A8.78,8.78,0,0,1,9.5,15.65V2.76H27.82V15.65A8.74,8.74,0,0,1,27.07,19.14ZM2.77,3.81a1,1,0,0,1,1-1h3V13.44A14.41,14.41,0,0,1,2.77,3.81ZM23,35.54H14.29c0-1.59,1.71-2.9,3.9-3.07h.94C21.33,32.64,23,34,23,35.54ZM34.56,3.81a14.41,14.41,0,0,1-4,9.63V2.76h3A1,1,0,0,1,34.56,3.81Z"
        />
      </g>
    </g>
  </svg>
);

export default PersonalBest;
